import { useSyncExternalStore } from 'react'
import {
    clearTargetStorage,
    getTargetStorageSnapshot,
    setTargetStorage,
    subscribeTargetStorage,
    type TargetStorageSnapshot,
} from '@/utils/targetStorage'

const SERVER_SNAPSHOT: TargetStorageSnapshot = { docId: null, name: null }

const useTargetStorage = () => {
    const snapshot = useSyncExternalStore(
        subscribeTargetStorage,
        getTargetStorageSnapshot,
        () => SERVER_SNAPSHOT,
    )

    return {
        targetStorageDocId: snapshot.docId ?? undefined,
        targetStorageName: snapshot.name ?? undefined,
        setTargetStorage,
        clearTargetStorage,
    }
}

export default useTargetStorage
